import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
// Entradas más usadas: import estático evita pantalla en blanco si falla la carga de un chunk dinámico.
import HomePage from '../pages/home/page';
import LoginPage from '../pages/login/page';
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const TicketsPage = lazy(() => import('../pages/tickets/page'));
const CreateTicketPage = lazy(() => import('../pages/create-ticket/page'));
const TicketDetailPage = lazy(() => import('../pages/ticket-detail/page'));
const ReportsPage = lazy(() => import('../pages/reports/page'));
const PlantsPage = lazy(() => import('../pages/plants/page'));
const ClientsPage = lazy(() => import('../pages/clients/page'));
const UsersPage = lazy(() => import('../pages/users/page'));
const DepartmentsPage = lazy(() => import('../pages/departments/page'));
const CategoriesPage = lazy(() => import('../pages/categories/page'));
const ContactsPage = lazy(() => import('../pages/contacts/page'));
const ContractsPage = lazy(() => import('../pages/contracts/page'));
const ServiceTypesPage = lazy(() => import('../pages/service-types/page'));
const AuditLogPage = lazy(() => import('../pages/audit-log/page'));
const SLADashboardPage = lazy(() => import('../pages/sla-dashboard/page'));
const NotificationsPage = lazy(() => import('../pages/notifications/page'));
const SettingsPage = lazy(() => import('../pages/settings/page'));
const PublicTicketPage = lazy(() => import('../pages/public-ticket/page'));
const ResetPasswordPage = lazy(() => import('../pages/reset-password/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const PortalReviewPage = lazy(() => import('../pages/portal-review/page'));
const Layout = lazy(() => import('../components/feature/Layout'));
const ProtectedRoute = lazy(() => import('../components/feature/ProtectedRoute'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/submit-ticket',
    element: <PublicTicketPage />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/portal-review/:ticketId',
    element: <PortalReviewPage />,
  },
  {
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: '/dashboard',
        element: <DashboardPage />,
      },
      {
        path: '/tickets',
        element: <TicketsPage />,
      },
      {
        path: '/create-ticket',
        element: <CreateTicketPage />,
      },
      {
        path: '/ticket/:id',
        element: <TicketDetailPage />,
      },
      {
        path: '/reports',
        element: <ReportsPage />,
      },
      {
        path: '/plants',
        element: <PlantsPage />,
      },
      {
        path: '/clients',
        element: <ClientsPage />,
      },
      {
        path: '/users',
        element: <UsersPage />,
      },
      {
        path: '/departments',
        element: <DepartmentsPage />,
      },
      {
        path: '/categories',
        element: <CategoriesPage />,
      },
      {
        path: '/contacts',
        element: <ContactsPage />,
      },
      {
        path: '/contracts',
        element: <ContractsPage />,
      },
      {
        path: '/service-types',
        element: <ServiceTypesPage />,
      },
      {
        path: '/audit-log',
        element: <AuditLogPage />,
      },
      {
        path: '/sla-dashboard',
        element: <SLADashboardPage />,
      },
      {
        path: '/notifications',
        element: <NotificationsPage />,
      },
      {
        path: '/settings',
        element: <SettingsPage />,
      },
    ]
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
